import { permissions } from '@utilities-one/api-sdk';

/** Any-of: manage implies view (UG-5190). Used by the nav item, the top header and routeAccess. */
export const CHANGE_ORDERS_VIEW_PERMISSIONS: string[] = [
  permissions.projectManagement.financialForecast.viewChangeOrders,
  permissions.projectManagement.financialForecast.manageChangeOrders,
];
